import { TabContainer, TabButton } from './styles'

export default function ItemTabs ({
  tabs = [],
  selectedTab,
  tabWidth = 140,
  containerStyle = {},
  onTabChange = () => {}
}) {
  return (
    <TabContainer style={containerStyle}>
      {tabs.map ((tab, index) => (
        <TabButton
          key={index}
          type='button'
          selected={selectedTab === tab.value}
          width={tabWidth}
          onClick={() => onTabChange (tab.value)}
          disabled={tab.disabled}
        >
          {tab.label}
        </TabButton>
      ))}
    </TabContainer>
  )
}
